export const aboutContent = {
  brandStory: {
    title: '品牌故事',
    paragraphs: [
      '玫瑰视频创立于2018年，总部位于中国深圳。从最初的小型影视资源聚合平台起步，经过多年的技术积累和用户口碑沉淀，如今已发展成为拥有超过5800万注册用户的综合性在线视频平台。',
      '我们深知，在这个信息爆炸的时代，用户最需要的不是更多的选择，而是更好的选择。因此，玫瑰视频始终秉持"精选内容、极致体验"的核心理念，通过智能推荐算法和人工精选相结合的方式，为用户筛选出最值得观看的优质内容。',
      '"玫瑰"象征着热情与美好，正如我们对视频内容的热爱和对用户体验的追求。每一部剧集、每一部电影，都承载着创作者的心血和观众的情感连接。玫瑰视频致力于成为连接优质内容与观众的最佳桥梁。',
    ],
  },
  values: [
    { title: '内容为王', description: '坚持精选优质内容，拒绝低质内容和信息噪音，让每一分钟观影都物有所值。', icon: 'ri-star-line' },
    { title: '技术驱动', description: '自主研发视频加速引擎和智能推荐系统，确保播放流畅不缓冲，内容推荐精准个性化。', icon: 'ri-cpu-line' },
    { title: '用户至上', description: '以用户体验为核心，持续优化界面设计和功能体验，打造极致观影体验。', icon: 'ri-user-heart-line' },
    { title: '合法合规', description: '严格遵守国家法律法规，坚持正版内容授权，为行业健康发展贡献力量。', icon: 'ri-shield-check-line' },
  ],
  milestones: [
    { year: '2018', event: '玫瑰视频正式上线，首月注册用户突破10万' },
    { year: '2019', event: '完成A轮融资，视频资源库突破1万部' },
    { year: '2020', event: '用户突破1000万，推出智能推荐算法2.0' },
    { year: '2021', event: '获得"最佳用户体验视频平台"奖项' },
    { year: '2022', event: '视频资源库突破5万部，日均播放量超5000万次' },
    { year: '2023', event: '注册用户突破5000万，推出AI个性化推荐系统' },
    { year: '2024', event: '上线短剧频道，覆盖更多内容品类' },
    { year: '2025', event: '完成品牌升级，用户总规模达5800万+' },
  ],
  testimonials: [
    {
      name: '王小明',
      role: '资深影评人',
      content: '玫瑰视频的片源质量和播放流畅度在行业内是数一数二的。作为一名影评人，我经常在这里发现一些优秀的冷门佳作，推荐算法确实很懂我的口味。',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20man%20portrait%20headshot%2C%20clean%20white%20background%2C%20professional%20lighting%2C%20simple%20composition&width=120&height=120&seq=avatar-01&orientation=squarish',
    },
    {
      name: '李婷',
      role: '都市白领',
      content: '每天下班回家最大的放松就是打开玫瑰视频追剧。高清画质、没有广告打扰，而且更新特别快，基本上电视上播完第二天就能看到了。',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20portrait%20headshot%2C%20clean%20white%20background%2C%20soft%20professional%20lighting%2C%20simple%20composition&width=120&height=120&seq=avatar-02&orientation=squarish',
    },
    {
      name: '张伟',
      role: '影视专业学生',
      content: '作为影视专业的学生，玫瑰视频丰富的分类和纪录片资源对我的学习帮助很大。尤其是纪录片区，有很多国内外的优质内容，非常推荐。',
      avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20student%20man%20portrait%20headshot%2C%20clean%20white%20background%2C%20casual%20professional%20lighting%2C%20simple%20composition&width=120&height=120&seq=avatar-03&orientation=squarish',
    },
  ],
  contact: {
    address: '广东省深圳市南山区科技园南路88号玫瑰大厦18层',
    phone: '400-888-6666',
    email: 'contact@meiguishipin.com',
    workingHours: '周一至周日 9:00 - 21:00',
  },
};